export const usePersistentStorage = () => {
    const { localStorage } = window;
    const { setItem, getItem, removeItem, clear } = localStorage;
    return {
        setItem: setItem.bind(localStorage),
        getItem: getItem.bind(localStorage),
        removeItem: removeItem.bind(localStorage),
        clear: clear.bind(localStorage)
    };
};
